export default {
  "HELLO": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你好"])},
  "Account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户设置"])},
  "List with us": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["出租房源"])},
  "user": {
    "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["即将开始的预定"])},
    "become": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成为房东"])}
  },
  "host": {
    "New Orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新订单"])},
    "Booking Calendar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["预定日历"])}
  }
}